/**
 * 活動短網址轉址頁：/g/:shortCode
 * 向後端取得 redirectUrl 後導向前端 Join 長網址，對外短網址顯示前端網域
 */

import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getApiBase } from '../../api/apiUtils';

export function ShortRedirectPage() {
  const { shortCode } = useParams<{ shortCode: string }>();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!shortCode?.trim()) {
      setError('短碼無效');
      return;
    }

    let cancelled = false;
    const apiBase = getApiBase();
    const url = `${apiBase}/api/lite/short/${encodeURIComponent(shortCode.trim())}`;

    fetch(url)
      .then(res => {
        if (cancelled) return;
        if (!res.ok) {
          return res.json().then((body: { error?: string }) => {
            throw new Error(body?.error || `無法解析短網址（${res.status}）`);
          });
        }
        return res.json() as Promise<{ redirectUrl: string }>;
      })
      .then(data => {
        if (cancelled || !data?.redirectUrl) return;
        window.location.href = data.redirectUrl;
      })
      .catch(err => {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : '轉址失敗');
        }
      });

    return () => {
      cancelled = true;
    };
  }, [shortCode]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4 bg-gray-50">
        <p className="text-gray-600">{error}</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-blue-500 border-t-transparent mx-auto mb-3" />
        <p className="text-gray-600">轉址中...</p>
      </div>
    </div>
  );
}
